import * as React from 'react';
import styled from "styled-components";
import {Title, SectionTitle} from "../../styled"
import BannerImage from '../../images/resources-banner.png';

const Boxes = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 14px;
`;

const Box = styled.div`
  display: grid;
  gap: 8px;
  max-width: 459px;
`;

const BoxTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0.01em;

`;

const BoxText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #67686B;
`;

const Banner = styled.div`
  border-radius: 20px;
  margin-bottom: 40px;
  
  img {
    width: 100%;
    object-fit: cover;
  }
`;

const Container = styled.div`
  margin-left: 90px;

  ${Title} {
    max-width: 686px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 1270px) {
    margin: 0;
  }
`;

/**
 * render landing page resources section
 * @constructor
 */
export default function Resources(): React.ReactElement {
  return (
    <Container>
      <SectionTitle>ресурсы и время</SectionTitle>
      <Title>
        Уже знаете, как использовать
        <span> освободившиеся </span>
        ресурсы и время?
      </Title>
      <Boxes>
        <Box>
          <BoxTitle>
            Платформа предназначена
            для самого быстрого и эффективного создания контента.
          </BoxTitle>
          <BoxText>
            Сэкономленное время и ресурсы предлагаем использовать
            для развития бизнеса и взрывного роста.
            Команда Grow Place приложит все усилия,
            для возможности успешной реализации.
          </BoxText>
        </Box>
        <Box>
          <BoxTitle>
            Мы прекрасно понимаем потребности
            при организации онлайн бизнеса,
            имеем большой опыт в маркетинге и образовании.
          </BoxTitle>
          <BoxText>
            Мы провели сотни бессонных ночей за работой
            и мы точно знаем, как бывает тяжело
            при создании и проведении онлайн курсов.
            Особенно, когда важно качество
            не только материала, но и эко-системы вокруг контента.
          </BoxText>
        </Box>
      </Boxes>
      <Banner>
        <img src={BannerImage} alt="banner"/>
      </Banner>
    </Container>
  );
}
